module.exports = __webpack_public_path__ + "img/PRT.fea5bb77.svg";